import React from "react";
import LoadingInput from "../../LoadingInput";
import Text from "../../Text";
import styled from "styled-components";
import { getCities } from "../../../api/address";


const ListWrapper = styled.ul`
  list-style: none;
  max-height: 150px;
  overflow-y: scroll;
`;

const ListItem = styled.li`
  background-color: #fff;
  padding: 5px;
  border: 1px solid #ccc;
  cursor: pointer;
  :hover {
    background-color: #ebebeb;
    color: black;
  }
`;

export default (props) => {
  const [input, setInput] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [cities, setCities] = React.useState([]);

  function onSearch(value) {
    if (value.length >= 3) {
      setLoading(true);
      getCities({ city: value, uf_code: props.stateCode })
        .then((data) => {
          setCities(data);
          setLoading(false);
          setInputFocus();
        })
        .catch((error) => {
          setLoading(false);
        });
    }
  }

  function onChange(e) {
    const { value } = e.target;
    setInput(value);
    if (value.length >= 3 || e.key === "Enter") {
      setTimeout(() => onSearch(value), 100);
    }
  }

  function setInputFocus() {
    document.getElementById("input-auto-complete-search-city").focus();
  }

  function onSelectCity(city) {
    if (props.onChange) {
      props.onChange({ target: { name: "city_location", value: city.id } });
    }
    setInput(city.city_name);
    setCities([]);
    setInputFocus();
  }

  return (
    <div className="">
      <div className="form-group">
        <div className="form-label">
          <Text color="primary">Cidade </Text>
        </div>
        <LoadingInput
          // disabled={loading || props.disabled || !props.stateCode}
          loading={loading}
          id="input-auto-complete-search-city"
          name="city_location"
          placeholder={`${
            !props.stateCode ? "Selecione o Estado" : "Digite a cidade"
          }`}
          onChange={onChange}
          value={input || props.defaultInputValue}
        />
      </div>
      <ListWrapper className="list-group">
        {cities.map((city) => (
          <ListItem
            onClick={() => onSelectCity(city)}
            key={city.id}
            className="list-group-item"
          >
            {city.city_name}
          </ListItem>
        ))}
      </ListWrapper>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/_components/Address/CityLocation/index.jsx